import {
  FaBalanceScale,
  FaCalculator,
  FaUsers,
  FaBuilding,
  FaFileInvoice,
} from "react-icons/fa";

export const servicios = [
  {
    id: "asesoramiento",
    titulo: "Módulo Asesoramiento",
    icon: <FaBalanceScale />,
    descripcion:
      "Brindamos asesoramiento permanente y personalizado para tu organización, adaptado a cada etapa de crecimiento empresarial. Acompañamos en decisiones estratégicas y operativas con una visión integral.",
    contenido: [
      "Administración: mejora de procesos y gestión interna.",
      "Finanzas: planificación, análisis de inversiones y control de fondos.",
      "Contabilidad: seguimiento contable y soporte normativo.",
      "Impuestos: planificación fiscal estratégica y cumplimiento.",
      "Cargas sociales: orientación en aportes y normativa laboral.",
      "Recursos humanos: gestión de personal, contratos y liquidaciones.",
      "Organización social: asesoramiento jurídico institucional.",
    ],
  },
  {
    id: "contable",
    titulo: "Módulo Contable",
    icon: <FaCalculator />,
    descripcion:
      "Garantizamos transparencia y confiabilidad en la información contable para facilitar la toma de decisiones y asegurar el cumplimiento normativo.",
    contenido: [
      "Preparación de estados contables: balances y resultados.",
      "Informes y certificaciones contables.",
      "Auditoría de estados contables.",
      "Análisis y proyección financiera de estados contables.",
    ],
  },
  {
    id: "sueldos",
    titulo: "Módulo Sueldos y Cargas Sociales",
    icon: <FaUsers />,
    descripcion:
      "Ofrecemos soluciones completas en liquidación de sueldos y obligaciones laborales, cumpliendo con la legislación vigente.",
    contenido: [
      "Liquidación de sueldos: haberes, extras y licencias.",
      "Cargas sociales: aportes y contribuciones.",
      "Altas y bajas de empleados ante organismos.",
      "Confección del libro de sueldos obligatorio.",
    ],
  },
  {
    id: "societario",
    titulo: "Módulo Societario",
    icon: <FaBuilding />,
    descripcion:
      "Acompañamos en la constitución, organización y transformación de sociedades, ajustándonos a la normativa legal vigente.",
    contenido: [
      "Encuadre societario: análisis de figura legal ideal.",
      "Constitución de sociedades: estatutos y trámites.",
      "Modificaciones al capital social.",
      "Transformación societaria y adecuación estatutaria.",
    ],
  },
  {
    id: "impuestos",
    titulo: "Módulo Liquidación de Impuestos",
    icon: <FaFileInvoice />,
    descripcion:
      "Nos ocupamos del cumplimiento fiscal integral, determinando y presentando impuestos nacionales, provinciales y municipales.",
    contenido: [
      "Impuesto a las Ganancias.",
      "Bienes Personales.",
      "IVA y percepciones/retenciones (SICORE, SIRCREB, etc.).",
      "Ingresos Brutos (Convenio Multilateral y local).",
      "Renta financiera y participaciones societarias.",
      "Libros IVA ventas y compras.",
      "Control de cuentas corrientes tributarias.",
      "Inscripciones ante ARCA.",
      "Asesoramiento a monotributistas.",
    ],
  },
];
